import React, { useState } from "react";
import { Box, Card, Stack, Typography, Button } from "@mui/material";
import deleteCart from "../../assets/delete-cart.png";
import "./CartItemCard.scss";
import { LOCALSTORAGE_KEY, orderType } from "../../utils/Constants";
import {
  getTempleName,
  getItemType,
  truncateToTwoDecimals,
} from "../../utils/HelperFunctions";
import { useDispatch, useSelector } from "react-redux";
import { useTransition, animated } from "react-spring";
import { useNavigate } from "react-router-dom";
import { removeItemFromCartAction } from "../../store/actions/cartAction";
import DeleteConfirmDialog from "../dialog/DeleteConfirmDialog";
import { useTranslation } from "react-i18next";
import { LOCALIZATION } from "../../utils/localization";
import ImageView from "../ImageView/ImageView";
import {
  getOrderQuantityClertap,
  getTotalCartPrice,
  trackCleavertapEvent,
} from "../../utils/analyics/analyticsHelper";
import { ANALYTICS_EVENTS } from "../../utils/analyics/analyticsEvents";
const CartItemCard = ({ cartItems, handleClose }: any) => {
  const { t, i18n } = useTranslation();
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const priceConversionState = useSelector(
    (state: any) => state.priceConversion,
  );
  const { rate = 1, isOverseas = false } =
    priceConversionState.priceConversionRate || {};
  const savedLanguage =
    localStorage.getItem(LOCALSTORAGE_KEY.LANG_CODE) ?? "en";
  const { userInfo, selectedAddressId, currentGPSAddress } = useSelector(
    (state: any) => state.user,
  );
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [cartIdToDelete, setCartIdToDelete] = useState<any>(null);

  const transitions = useTransition(cartItems, {
    keys: (item: any) => item.cartId, // key should be unique for each cart item
    from: { opacity: 1, transform: "translateY(0px)" },
    enter: { opacity: 1, transform: "translateY(0px)" },
    leave: { opacity: 0, transform: "translateY(-30px)" },
    config: { tension: 250, friction: 20 },
  });

  const handleDeleteClick = (cartId: any) => {
    setCartIdToDelete(cartId);
    setDeleteDialogOpen(true);
  };

  const handleConfirmDelete = () => {
    if (cartIdToDelete) {
      try {
        const cartPayload = cartItems.find(
          (item: any) => item.cartId === cartIdToDelete,
        );
        if (cartPayload) {
          const _priceValue = isOverseas
            ? truncateToTwoDecimals(
                (cartPayload?.priceInfo?.finalPrice ?? 0) * rate,
              )
            : cartPayload?.priceInfo?.finalPrice;
          const payload = {
            User_ID: userInfo?.id ?? "Guest User",
            Cart_ID: cartIdToDelete,
            Item_Type: cartPayload?.orderType,
            Item_ID: cartPayload?.pujaDetails?.pujaNameKey ?? "",
            Item_Name:
              cartPayload?.pujaDetails?.pujaName ??
              cartPayload?.templeDetails?.chadhavaTitle ??
              "",
            Temple_ID: cartPayload?.templeDetails?.nameKey ?? "",
            Temple_Name: cartPayload?.templeDetails?.personalInfo?.name ?? "",
            Price: _priceValue ?? 0,
            Quantity: getOrderQuantityClertap(cartPayload),
            Currency:
              priceConversionState?.priceConversionRate?.currencyCode ?? "INR",
            Cart_Size: cartItems?.length-1,
            Cart_Value: isOverseas
              ? truncateToTwoDecimals(getTotalCartPrice(cartItems?.filter((_item:any)=> _item?.cartId !== cartIdToDelete)) * rate)
              : (getTotalCartPrice(cartItems?.filter((_item:any)=> _item?.cartId !== cartIdToDelete)) ?? 0),
            IsOverseas: isOverseas,
            rate: rate ?? 1,
            IsPrasad: cartPayload?.isPrasad ?? false,
            IsSubscribed: cartPayload?.isSubscribed ? true : false,
          };
          trackCleavertapEvent(ANALYTICS_EVENTS.Remove_from_Cart, payload);
        }
        dispatch(
          removeItemFromCartAction(userInfo?.phoneNumber, cartIdToDelete),
        );
      } catch (error) {
        console.log("Error", error);
      }
    }
    setDeleteDialogOpen(false);
    setCartIdToDelete(null);
  };

  const handleCancelDelete = () => {
    setDeleteDialogOpen(false);
    setCartIdToDelete(null);
  };

  const handleBookPuja = (cartId: string) => {
    navigate(`/checkoutV2/reviewCart?cartId=${cartId}`);
    handleClose();
  };

  return (
    <>
      <Card className="cartMenuItemSection">
        {transitions((style: any, data: any) => {
          return (
            <animated.div
              className="cartItemCard"
              style={style}
              key={data?.cartId}
            >
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                spacing={2}
              >
                <Box className="cardLeftInfo">
                  <Box className="bookingImage">
                    {data?.pujaDetails?.pujaBg?.uri ? (
                      <ImageView
                        src={data.pujaDetails.pujaBg.uri}
                        alt="Puja Background"
                      />
                    ) : data?.templeDetails?.personalInfo?.media?.pictures[0]
                        ?.pictureUrl ? (
                      <ImageView
                        src={
                          data.templeDetails.personalInfo.media.pictures[0]
                            .pictureUrl
                        }
                        alt="Temple Image"
                      />
                    ) : null}
                  </Box>

                  <Box className="itemTextInfo">
                    <Typography className="templeName">
                      {getTempleName(data?.templeDetails, savedLanguage)}{" "}
                      {data?.pujaDetails?.pujaName &&
                        (data?.orderType === orderType.pujaPackage ||
                          data?.orderType === orderType.chadhavaPackage) &&
                        ` ${data.pujaDetails.pujaName}`}
                    </Typography>

                    <Typography className="itemType">
                      {data?.orderType === orderType.pujaPackage ||
                      data?.orderType === orderType.chadhavaPackage
                        ? data?.orderType
                        : getItemType(data)}
                    </Typography>
                  </Box>
                </Box>

                <Box className="cardRightInfo">
                  <Button
                    onClick={(e: any) => {
                      e.preventDefault();
                      handleBookPuja(data?.cartId);
                    }}
                    aria-label="View"
                  >
                    View
                  </Button>
                </Box>
                <Box className="deleteCart">
                  <Box
                    component="img"
                    src={deleteCart}
                    alt="Delete"
                    onClick={(e: any) => {
                      e.preventDefault();
                      handleDeleteClick(data?.cartId);
                    }}
                  />
                </Box>
              </Stack>
            </animated.div>
          );
        })}
      </Card>
      <DeleteConfirmDialog
        open={deleteDialogOpen}
        onClose={handleCancelDelete}
        onConfirm={handleConfirmDelete}
        msg={t(LOCALIZATION.Multiple_Cart_Delete_Msg)}
      />
    </>
  );
};

export default CartItemCard;
